import React from "react";

const FifthSection = () => {
  return (
    <div data-aos="fade-down-right" className="mt-10 shadow-md shadow-slate-400 p-5">
      <h1 className="text-2xl text-primary font-semibold underline text-left">
        Bringing The Inevitable Future Forward:{" "}
      </h1>
      <p className="mt-2 text-lg font-medium text-slate-600 text-left">
        There’s a vibe shift underway, as we get closer and closer to a post
        scarcity economy, the eternal currency of the future of good karma will
        become more clear. <br />
        <br />
        For the greedy who still wish to hold on to ownership of something land
        is going to skyrocket as an asset, ownership on plots of earth will be
        seen as one of the steadiest investments as we approach a hyper decrease
        in the cost of building. <br />
        <br />
        The people who recognize this shift will do well to mortgage their
        house, buying a larger plot of land somewhere. <br />
        <br />
        If super-intelligence is democratic, honoring that ownership of land
        will be a decision the world makes. (Clearly the idea that those who
        hoarded their wealth and tried to hold on to value should have more
        value than those who put their wealth to work, giving up their assets,
        is one that will be a hard attempt) Propaganda for people to relinquish
        their assets to funds more of the poverty of the world will help the
        world make this decision when the time comes. <br />
        <br />
        While theres no specific data for what defines “Luxury” housing, this is
        of course a{" "}
        <a
          className="link-primary underline
"
          href="https://www.savills.com/impacts/market-trends/the-total-value-of-global-real-estate.html#:~:text=The"
        >
          {" "}
          far larger asset class{" "}
        </a>{" "}
        which outshines the luxury car and luxury goods market. <br />
        <br />
        What actually makes one house better than the other (often its simply
        the status it has rather than utility) if it was all about utility
        people would buy the cheaper house and install the heated seat toilets,
        and floors etc. (but then how would people respect them more?). What if
        we were not ranked by the size of our house, but instead by the size of
        our donations. <br />
        <br />
        You may remember that app that was $999 called “Im rich” and did
        nothing. That’s what designer clothing represents today. Useless expense
        for materials with patterns that represent pure vanity. Pure spending
        power gone to pure status. <br />
        <br />
        It is tasteless…. and we believe society is not only waking up to that
        fact, but it is inevitable that we will create better alternatives.{" "}
        <br />
        <br />
        In a subjective culture sense we see IN-YOUR-FACE luxury style goods
        declining while a push for understated looks are coming forward. Brands
        such as Gucci are being seen as more oversaturated, and pieces that lack
        design besides the plastery of the luxury logo on the piece are seen as
        tacky. <br />
        <br />
        Evidence of this: <br />
        <br />
        Brands like Gucci are becoming less hip. Designer brands that are in
        your face are not it. <br />
        <br />
        Designer that’s low-key is now the trend. <br />
        <br />
        Designer is dialing back as consumers replace spending to these models.{" "}
        <br /> <br />
        We believe the changing of status starting at a clothing level will
        cause one of the largest wealth flow transfers towards good for the
        world. Imagine an individual who is struggling to provide for
        themselves, eventually however, they begin to thrive. They start a
        business and after having major success exit for a few million dollars.
        What is the standard look and lifestyle of this person after this event?{" "}
        <br />
        <br />
        For the most part, most people are living to keep their “social survival
        mammoth” feeling good. This is the part of the brain which feeds off of
        status, which defines our place in the social hierarchy. And this is not
        something I believe we can change, people WILL naturally compete to go
        up the chain of the social hierarchy, people want to outdo each other,
        people are competitive, people are different and respect should be given
        where it is due. <br /> <br />
        This climb, this fight up the ladder is not inherently bad, what's wrong
        right now is what we consider to be markers of people who are higher up
        that ladder. We have been sold a narrative by the luxury and designer
        corporations, who have massive budgets to win the celebrities over, that
        designer and luxury clothing IS high status. Those who spend $4k on a
        designer bag versus one of equivalent quality for $50 are put higher on
        the status scale. If we can collectively redefine this status symbol as
        tacky, which has already been changing for in-your-face luxury design
        brand styles, we will change where the money which pays for status goes.{" "}
        <br /> <br />
        While projects like Shelter NFT would build a home for a family who
        would have otherwise never had one before for the same price as a
        designer bag, it is no replacement for a BAG. People still want to buy a
        high end item, so instead, a brand which offers that price of bag, that
        level of quality, whose surplus funds goes towards making that positive
        change is perfect. <br />
      </p>
    </div>
  );
};

export default FifthSection;
